import {
  Component,
  HostListener,
  inject,
  Input,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AppConstant } from 'src/app/shared/utilities/app.constant';

import { AsyncPipe, NgClass } from '@angular/common';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { PrimeTemplate } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { DialogService } from 'primeng/dynamicdialog';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import {
  BehaviorSubject,
  catchError,
  filter,
  finalize,
  of,
  take,
  takeUntil,
  takeWhile,
} from 'rxjs';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { NotificationSettingComponent } from 'src/app/shared/components/notification-setting/notification-setting.component';
import { PhotoCropperComponent } from 'src/app/shared/components/photo-cropper/photo-cropper.component';
import { IConfirmDialog } from 'src/app/shared/interface/common';
import { LocationSettingsOption } from 'src/app/shared/interface/location-settings.interface';
import { AzureAdService } from 'src/app/shared/services/azure-ad.service';
import { ConfirmDialogService } from 'src/app/shared/services/confirm-dialog.service';
import { LoaderLayOut } from 'src/app/shared/services/loaderLayOut.service';
import { LocationService } from 'src/app/shared/services/location.service';
import { LocationSettingsService } from 'src/app/shared/services/location-settings.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { UserInfoService } from 'src/app/shared/services/user-info.service';
import { DialogAction, OptionButtonType } from 'src/app/shared/type';
import { AppHelper } from 'src/app/shared/utilities/app.helper';
import { environment } from 'src/environments/environment';
import { Mode } from 'src/lib/mode-toggle/mode-toggle.model';
import { ModeToggleService } from 'src/lib/mode-toggle/mode-toggle.service';
import { TranslationTextService } from 'src/lib/translation/translation.service';
import { LanguageToken } from 'src/lib/translation/translation.token';
import { PreferredLanguague } from 'src/lib/translation/translation.type';
import jpack from '../../../../../package.json';
import { CustomizableButtonComponent } from '../../../shared/components/customizable-button/customizable-button.component';
import { SingleSwitchComponent } from '../../../shared/components/form-control/single-switch/single-switch.component';
import { LoadingComponent } from '../../../shared/components/loading/nonPercentageLoading/loading/loading.component';
import { BlobImageDirective } from '../../../shared/directives/blob.directive';
import { InnerMsgDirective } from '../../../shared/directives/inner-msg.directive';
import { NumbersOnly } from '../../../shared/directives/number-only.directive';
import { RandomAvatarDirective } from '../../../shared/directives/random-value/random-avatar.directive';
import { User } from '../../../shared/models/user.model';
import { StringShortFileNamePipe } from '../../../shared/pipes/string/string-shortFileName.pipe';

@Component({
  templateUrl: './home-user-information.component.html',
  selector: 'app-home-user-information',
  styleUrls: ['./home-user-information.component.scss'],
  imports: [
    DrawerModule,
    PrimeTemplate,
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    SingleSwitchComponent,
    CustomizableButtonComponent,
    RandomAvatarDirective,
    BlobImageDirective,
    TooltipModule,
    FileUploadModule,
    InputTextModule,
    InnerMsgDirective,
    SelectModule,
    NumbersOnly,
    ButtonModule,
    LoadingComponent,
    AsyncPipe,
    StringShortFileNamePipe,
    SvgIconComponent,
  ],
  providers: [DialogService],
})
export class HomeUserInformationComponent extends BaseComponent {
  isLoading: boolean = false;
  isViewer: boolean = false;

  @Input() displaySidebarUserInfomation: boolean = false;

  confirmDialog: IConfirmDialog = AppConstant.DEFAULT_DIALOG;

  languageToken = inject(LanguageToken);

  alertPreferredLanguage: PreferredLanguague;
  chatPreferredLanguage: PreferredLanguague;

  constructor(
    private _userInfoService: UserInfoService,
    private _msalService: MsalService,
    private _azureAdService: AzureAdService,
    private _builder: FormBuilder,
    private _notificationService: NotificationService,
    private _router: Router,
    private _dialogService: DialogService,
    private _loaderLayOut: LoaderLayOut,
    private _confirmService: ConfirmDialogService,
    private _modeToggleService: ModeToggleService,
    private _translationTextService: TranslationTextService,
    private _locationService: LocationService,
    private _locationSettingsService: LocationSettingsService
  ) {
    super();
  }

  theme: Mode = Mode.DARK;
  status: boolean = false;

  toggle() {
    this.theme = this._modeToggleService.toggleMode();
    this.status = this.theme === Mode.DARK ? true : false;
  }

  // Variable of Form
  public formUserGroup: FormGroup;

  public fieldNameKeys = {
    halId: 'halId',
    role: 'role',
    psl: 'psl',
    country: 'country',
    timezone: 'timezone',
    dialCode: 'dialCode',
    phone: 'phone',
    flag: 'flag',
    avatar: 'avatar',
    alertPreferredLanguage: 'alertPreferredLanguage',
    chatPreferredLanguage: 'chatPreferredLanguage',
  };

  public messageErrors: any = {
    required: 'Please fill in the information.',
    whitespace: 'Please fill in the information without white space.',

    minlength: 'Please enter phone more 6 numbers',
    maxlength: 'Please enter phone less 12 numbers',
  };

  countries: any[] = [];
  timezones: any[] = [];
  PSLs: any[] = [];

  currentUser!: User;

  uploadProgress = 0;

  isAuthenticated = false;
  ramdomAvatarCharacter: string = 'AA';

  @ViewChild('uploadAvatar') uploadAvatar?: FileUpload;

  linkFileAvt: string = '';
  fileLabel: string = 'Upload file';
  showCancelButton: boolean = false;

  totalFileSizeUpload = 10000000;
  currentImageSizeUpload = 0;

  flag_OpenDialog: boolean = false;

  formLoaded?: Promise<boolean>;
  isPreviewAvatar: boolean = false;

  // Checking Cropper Avatar is open/close
  isDialogCropperVisible: boolean = false;

  // Trong dialog cropper component
  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: Event): void {
    if (!this.isDialogCropperVisible) {
      this.closePanel();
    }
  }

  // State of Setting Dialog
  isOpenSetting$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  get userDisplayName(): string {
    return (
      this.currentUser?.displayName ||
      `${this.currentUser?.firstName || ''} ${this.currentUser?.lastName || ''}`.trim()
    );
  }

  APPLICATION_VERSION: string = `v0.0.0`;

  onInit(): void {
    // Handle Theme Mode
    this.theme = this._modeToggleService.getCurrentMode();
    this.status = this.theme === Mode.DARK ? true : false;

    this.loadTimezonesMetadata();

    // Refresh flag reload Team Management
    this._userInfoService.requestReloadUserManagement.next(false);
    this._userInfoService.requestReloadUserPermission.next(false);

    this._userInfoService.userSubject$
      .pipe(
        filter((userObject: User) => !!userObject?.id),
        takeWhile(
          (userObject: User) =>
            JSON.stringify(userObject) !== JSON.stringify(this.currentUser)
        )
      )
      .subscribe(currentUser => {
        if (currentUser && currentUser.id && currentUser.role) {
          this.isViewer = currentUser.role === AppConstant.ROLES.VIEWER.label;
          this.generateUserPanel(currentUser);

          this.APPLICATION_VERSION = `${jpack.version}`;
        }
      });
  }

  private normalizeUtcOffset(value?: string): string {
    if (!value) return '+00:00';
    let offset = value.replace(/^UTC/i, '').replace('±', '+').trim();
    if (!offset) return '+00:00';
    if (!offset.startsWith('+') && !offset.startsWith('-')) {
      offset = '+' + offset;
    }
    // Handle cases like "+7" or "+07" -> "+07:00"
    if (/^[+-]\d{1,2}$/.test(offset)) {
      const sign = offset[0];
      const num = offset.slice(1).padStart(2, '0');
      offset = `${sign}${num}:00`;
    }
    return offset;
  }

  private mapLocationTimezones(options: LocationSettingsOption[]): any[] {
    return options.map(option => {
      const utcOffset = this.normalizeUtcOffset(option.value);
      const matchedIana = AppConstant.TIME_ZONES_IANA.find(
        tz => tz.utcOffset === utcOffset
      )?.value;

      return {
        label: option.label,
        name: option.label,
        rawUtc: option.value,
        utcOffset: utcOffset,
        value: matchedIana || option.value,
        ianaTimezone: matchedIana || option.value,
      };
    });
  }

  private findMatchingTimezone(
    ianaTimezone?: string,
    timezoneOffset?: string
  ): any {
    if (!this.timezones?.length) {
      return null;
    }

    // 1. Try matching by direct IANA name / value / rawUtc in the current options list
    if (ianaTimezone) {
      const matchByIana = this.timezones.find(
        tz =>
          tz.value === ianaTimezone ||
          tz.ianaTimezone === ianaTimezone ||
          tz.rawUtc === ianaTimezone
      );
      if (matchByIana) {
        return matchByIana;
      }
    }

    // 2. If user has ianaTimezone but options list only contains UTC offsets,
    // look up the UTC offset of that IANA timezone from AppConstant.TIME_ZONES_IANA
    let derivedOffset: string | null = null;
    if (ianaTimezone && AppConstant.TIME_ZONES_IANA?.length) {
      const ianaEntry = AppConstant.TIME_ZONES_IANA.find(
        tz => tz.value === ianaTimezone || tz.name === ianaTimezone
      );
      if (ianaEntry?.utcOffset) {
        derivedOffset = this.normalizeUtcOffset(ianaEntry.utcOffset);
      }
    }

    // 3. Try matching by UTC offset (either derived from IANA or from user.timezone)
    const targetOffset =
      derivedOffset ||
      (timezoneOffset ? this.normalizeUtcOffset(timezoneOffset) : null);

    if (targetOffset) {
      const matchByOffset = this.timezones.find(
        tz => tz.utcOffset === targetOffset
      );
      if (matchByOffset) {
        return matchByOffset;
      }
    }

    return null;
  }

  private isLoadingTimezones = false;

  private loadTimezonesMetadata(): void {
    if (this.isLoadingTimezones) {
      return;
    }
    this.isLoadingTimezones = true;

    this._locationSettingsService
      .getLocationSettingsMetadata()
      .pipe(
        takeUntil(this.destroy$),
        catchError(() => of({ timeZones: [], unitSystems: [] })),
        finalize(() => {
          this.isLoadingTimezones = false;
        })
      )
      .subscribe(metadata => {
        if (metadata?.timeZones?.length) {
          this.timezones = this.mapLocationTimezones(metadata.timeZones);
          const matchedTimezone = this.findMatchingTimezone(
            this.currentUser?.ianaTimezone,
            this.currentUser?.timezone
          );
          if (matchedTimezone && this.formUserGroup) {
            const timezoneControl = this.formUserGroup.get(
              this.fieldNameKeys.timezone
            );
            if (timezoneControl && !timezoneControl.dirty) {
              timezoneControl.setValue(matchedTimezone);
            }
          }
        }
      });
  }

  generateUserPanel(userResponse: User) {
    this.currentUser = userResponse;
    this.currentUser.replaceCountry = this.currentUser.country
      ? this.currentUser!.country.slice(0, 2)
      : '';
    this.ramdomAvatarCharacter = this.getFirstLetter(
      this.currentUser?.displayName
    );

    this.countries = this._locationService.countries;
    if (!this.timezones?.length) {
      this.loadTimezonesMetadata();
    }
    this.PSLs = AppConstant.HALLIBURTON_PSLs;

    this.linkFileAvt = this.currentUser?.avatar || '';
    this.loadAvatarFromGraph();

    this.alertPreferredLanguage = {
      id: userResponse.userPreferredLanguageAlert,
      name: this.languageToken.getLanguageName({
        code: userResponse.userPreferredLanguageAlert,
      }),
      isSelected: true,
    };

    this.chatPreferredLanguage = {
      id: userResponse.userPreferredLanguage,
      name: this.languageToken.getLanguageName({
        code: userResponse.userPreferredLanguage,
      }),
      isSelected: true,
    };

    this._translationTextService.updatePreferredLanguage(
      this.alertPreferredLanguage
    );

    this.buildForm();
    // Load user information successfully
    this._loaderLayOut.setLoadingStatus('userInfoAPI', true);
  }

  /**
   * Refresh the avatar from Microsoft Graph so the panel shows the latest AD profile photo.
   */
  private loadAvatarFromGraph(): void {
    if (!this.currentUser?.halId) {
      return;
    }

    this._userInfoService
      .getUsersFromGraph(this.currentUser.halId)
      .pipe(
        takeUntil(this.destroy$),
        catchError(() => of({ data: [] }))
      )
      .subscribe(response => {
        const graphUser = (response?.data || []).find(
          (user: any) => user.avatar
        );
        if (graphUser?.avatar) {
          this.currentUser.avatar = graphUser.avatar;
          this.linkFileAvt = graphUser.avatar;
        }
      });
  }

  /**
   * Find country by dial code, preferring region match for countries with regions (e.g., US-NAM vs US-GOA)
   */
  private findCountryByDialCode(dialCode: string, regionToMatch?: string): any {
    return (
      this.countries.find(country => {
        if (country.dialCode === dialCode) {
          // For countries with regions (like US), prefer matching the specific region
          if (dialCode === '+1' && regionToMatch) {
            return country.code === 'US' && country.region === regionToMatch;
          }
          return true;
        }
      }) || this.countries.find(country => country.dialCode === dialCode)
    );
  }

  buildForm() {
    let valueCountry: any = null;
    let valueTimezone: any = null;
    let valueFlag: any;
    let valuePhone = '';
    let valueDial: any;

    const userDailCode = this.currentUser?.phone
      ? this.currentUser.phone.split(' ')[0]
      : '';

    // Parse country code and region from database (e.g., "US-NAM", "US-GOA", or "FR")
    const countryParts = this.currentUser?.country?.split('-') || [];
    const countryCode = countryParts[0];
    const countryRegion = countryParts[1]; // Will be undefined for countries without region

    // Use helper method to find country by dial code with region preference
    valueFlag = this.findCountryByDialCode(userDailCode, countryRegion);
    valueDial = this.findCountryByDialCode(userDailCode, countryRegion);

    if (valueDial && this.currentUser?.phone) {
      valuePhone = this.currentUser?.phone.replace(valueDial.dialCode, '');
      valuePhone = AppHelper.UtileFunctions.replaceAllCharacter(
        valuePhone,
        ' ',
        ''
      );
    }

    let roleDisplay = this.currentUser?.role;
    if (roleDisplay && roleDisplay == 'Support') {
      roleDisplay = 'Live Support';
    }

    if (this.currentUser?.country) {
      // Match country by code and region (if specified)
      valueCountry = this.countries.find(element => {
        if (countryRegion) {
          // Match both code and region for countries with region (e.g., "US-NAM")
          return (
            element.code === countryCode && element.region === countryRegion
          );
        } else {
          // Match by code only for countries without region
          return element.code === countryCode;
        }
      });
    }
    if (this.currentUser?.ianaTimezone || this.currentUser?.timezone) {
      valueTimezone = this.findMatchingTimezone(
        this.currentUser?.ianaTimezone,
        this.currentUser?.timezone
      );
    }

    this.formUserGroup = this._builder.group({
      [this.fieldNameKeys.halId]: [
        { value: this.currentUser?.halId, disabled: true },
      ],
      [this.fieldNameKeys.role]: [{ value: roleDisplay, disabled: true }],
      [this.fieldNameKeys.psl]: [
        {
          value:
            this.PSLs.find(psl => this.currentUser?.psl === psl.code)?.name ||
            `Can't load PSL Name of code: ${this.currentUser?.psl}`,
          disabled: true,
        },
      ],
      [this.fieldNameKeys.country]: [
        { value: valueCountry, disabled: true },
        [Validators.required],
      ],
      [this.fieldNameKeys.timezone]: [
        { value: valueTimezone, disabled: true },
        [Validators.required],
      ],
      [this.fieldNameKeys.flag]: [
        { value: valueFlag, disabled: true },
        [Validators.required],
      ],
      [this.fieldNameKeys.dialCode]: [valueDial?.dialCode],
      [this.fieldNameKeys.phone]: [
        {
          value: Number(valuePhone) !== 0 ? Number(valuePhone) : '',
          disabled: true,
        },
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(12),
        ],
      ],

      [this.fieldNameKeys.avatar]: [{ value: '', disabled: true }],
      [this.fieldNameKeys.alertPreferredLanguage]: [
        {
          value: this.alertPreferredLanguage,
          disabled: true,
        },
      ],
      [this.fieldNameKeys.chatPreferredLanguage]: [
        {
          value: this.chatPreferredLanguage,
          disabled: true,
        },
      ],
    });
  }

  get alertPreferredLanguageControl(): FormControl {
    return this.formUserGroup.get('alertPreferredLanguage') as FormControl;
  }

  get chatPreferredLanguageControl(): FormControl {
    return this.formUserGroup.get('chatPreferredLanguage') as FormControl;
  }

  loadNameofFileAvt(linkFileAvt: string) {
    if (!linkFileAvt) {
      this.fileLabel = 'Upload file';
      return;
    } else {
      this.fileLabel = AppHelper.UtileFunctions.getFileNameFromUrl(linkFileAvt);
      // Add a check for uploadAvatar
      if (this.uploadAvatar) {
        this.uploadAvatar._files = [];

        this.uploadAvatar._files.push(
          new File([new Blob()], 'Random.jpg', {
            type: 'image/jpg',
          })
        );
        this.formUserGroup.get('avatar')?.setValue('hasValue');
      }

      this.showCancelButton = true;
    }
  }

  enableEditing() {
    let countryControl = this.formUserGroup.get('country');
    let timezoneControl = this.formUserGroup.get('timezone');
    let phoneControl = this.formUserGroup.get('phone');
    let flagControl = this.formUserGroup.get('flag');
    let avatarControl = this.formUserGroup.get('avatar');
    let alertPreferredLanguage = this.formUserGroup.get(
      'alertPreferredLanguage'
    );
    let chatPreferredLanguage = this.formUserGroup.get('chatPreferredLanguage');

    countryControl?.enable();
    timezoneControl?.enable();
    phoneControl?.enable();
    flagControl?.enable();
    avatarControl?.enable();
    alertPreferredLanguage?.enable();
    chatPreferredLanguage?.enable();

    // set validation for phone
    this.flag_OpenDialog = true;

    this.loadNameofFileAvt(this.linkFileAvt);
  }

  disableEditing() {
    let countryControl = this.formUserGroup.get('country');
    let timezoneControl = this.formUserGroup.get('timezone');
    let phoneControl = this.formUserGroup.get('phone');
    let flagControl = this.formUserGroup.get('flag');
    let avatarControl = this.formUserGroup.get('avatar');

    countryControl?.disable();
    timezoneControl?.disable();
    phoneControl?.disable();
    flagControl?.disable();
    avatarControl?.disable();
  }

  getCroppedAvatar(file: any): void {
    // User selected invalid type file

    const errorUpload = this.uploadAvatar?.msgs;
    if (errorUpload?.length !== 0) {
      this._notificationService.setMessage({
        type: AppConstant.MESSAGE_TYPE.WARNING,
        header: AppHelper.StringFunctions.capitalizeFirstLetter(
          errorUpload![0].detail || 'Error upload'
        ),
        content: errorUpload![0].summary || 'Invalid file type',
      });
      // handle button cancel when choose invalid type
      this.onClear_avatar();
      return;
    }

    //

    this.currentImageSizeUpload = file.size;

    if (this.currentImageSizeUpload > this.totalFileSizeUpload) {
      this._notificationService.setMessage({
        type: AppConstant.MESSAGE_TYPE.WARNING,
        header: 'Upload Document',
        content: 'Maximum total upload size of Image and Specs is 10 MB.',
      });
      return;
    }

    this.formUserGroup.get('avatar')?.setValue(file);
  }

  onClear_avatar() {
    this.uploadAvatar!.chooseLabel = 'Upload file';
    this.uploadAvatar!.showCancelButton = false;

    this.isPreviewAvatar = false;

    this.showCancelButton = false;
    this.fileLabel = 'Upload file';

    this.formUserGroup.get('avatar')?.setValue('');

    this.currentImageSizeUpload = 0;
  }

  onHide() {
    this.closePanel();
  }

  closePanel() {
    if (this.flag_OpenDialog) {
      this._confirmService.setDialog({
        ...this.confirmDialog,
        isVisible: true,
        header: 'Discard',
        haveDialogMessage: true,
        dialogMessage: 'Do you want to leave without saving information?',
        havePrimaryButton: true,
        primaryButtonLabel: 'Discard',
        isValidPrimaryButton: true,
        disablePrimaryButton: false,
        haveSecondaryButton: true,
        secondaryButtonLabel: 'Cancel',
        buttonEvent: (event: OptionButtonType) =>
          this.onButtonClickDialog(event, 'Draft'),
      });
    } else {
      this.disableEditing();
      this._userInfoService.changeShowUserPanelStatus(false);

      if (
        this._router.url === '/user/team-management' &&
        this._userInfoService.requestReloadUserManagement.getValue() === true
      ) {
        // pass request reload to Team Management
        this._userInfoService.reloadUserManagement$.next(true);
      } else if (
        this._router.url.includes('/user/team-management/') &&
        this._userInfoService.requestReloadUserPermission.getValue() === true
      ) {
        // pass request reload to Team Management
        this._userInfoService.reloadUserPermission$.next(true);
      }
    }
  }

  addPrefixNumber(e: any) {
    this.formUserGroup.get('dialCode')?.setValue(e.value.dialCode);
  }

  public inputNumber_Clear_e(event: any) {
    let invalidChars = ['-', '+', 'e', 'E', '.'];

    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  public handlePasteInput(controlName: string, input: any) {
    let control = this.formUserGroup.get(controlName);

    // get paste data
    let textPaste = input.clipboardData.getData('text/plain');

    // remove AZaz -+eE from paste data
    let finalPaste = textPaste.replace(/[^0-9]+/g, '');

    control?.setValue(finalPaste);
    this.getRefresh('phone');

    input.preventDefault();
  }

  getRefresh(controlName: string) {
    const control = this.formUserGroup.get(controlName);
    control?.markAsDirty();
    control?.markAllAsTouched();
    control?.updateValueAndValidity();
  }

  saveUserSetting() {
    const formData = this.formUserGroup.getRawValue();
    this.isLoading = true;

    let payload = {
      avatar: formData.avatar,
      role: formData.role,
      psl: formData.psl,
      country:
        formData.country.regions?.length > 1
          ? `${formData.country.code}-${formData.country.region}` // Saves "US-NAM" or "US-GOA"
          : formData.country.code,
      timezone:
        typeof formData.timezone === 'string'
          ? formData.timezone
          : formData.timezone
            ? formData.timezone.utcOffset || formData.timezone.value
            : undefined,
      ianaTimezone:
        typeof formData.timezone === 'string'
          ? formData.timezone
          : formData.timezone
            ? formData.timezone.ianaTimezone || formData.timezone.value
            : undefined,
      phone: `${formData.flag.dialCode || formData.dialCode} ${formData.phone}`,
      languageAlert: formData.alertPreferredLanguage.id,
      languageChatBot: formData.chatPreferredLanguage.id,
    };

    this._userInfoService
      .updateUserProfile(payload)
      .pipe(
        take(1),
        catchError(AppHelper.UtileFunctions.handleError),
        takeUntil(this.destroy$),
        finalize(() => (this.isLoading = false))
      )
      .subscribe({
        next: (updateResponse: any) => {
          if (updateResponse?.data) {
            this._userInfoService.setUserInfor(updateResponse.data);

            this.generateUserPanel(updateResponse.data);
            // Add flag to refrest if we in /user/team-management
            this.flag_OpenDialog = false;
            this._userInfoService.requestReloadUserManagement.next(true);
            this._userInfoService.requestReloadUserPermission.next(true);

            this._notificationService.setMessage({
              type: AppConstant.MESSAGE_TYPE.SUCCESS,
              header: 'User Preferences',
              content: `Update Profile User: ${this.currentUser?.mail} successfully!`,
            });
            this.flag_OpenDialog = false;
            this.closePanel();
          }
        },
        error: (error: any) => {
          console.error(error);
          this._notificationService.setMessage({
            type: AppConstant.MESSAGE_TYPE.WARNING,
            header: 'User Preferences',
            content: error?.message || error,
          });
        },
      });
  }

  private reloadWindow() {
    window.location.reload();
  }

  languages: PreferredLanguague[] = [
    {
      id: null,
      name: 'None',
      isSelected: true,
    },
    {
      id: 'en',
      name: 'English',
      isSelected: true,
    },
    {
      id: 'es',
      name: 'Spanish',
      isSelected: true,
    },
    {
      id: 'pt',
      name: 'Portuguese',
      isSelected: true,
    },
  ];

  selectedLanguage: PreferredLanguague = {
    id: 'en',
    name: 'English',
    isSelected: true,
  };

  onLanguageChange(event: any) {
    this.selectedLanguage = event.value;
  }

  logout_Azure() {
    const currentAccount = this._msalService.instance.getActiveAccount();

    this._azureAdService.isUserLoggedIn.next(false);
    this._azureAdService.userNameLoggedIn.next(undefined);
    this._msalService.logoutRedirect({
      account: currentAccount,
      postLogoutRedirectUri: environment.logoutUrl,
    });
  }

  getFirstLetter(userName: string | undefined): string {
    if (!userName) return 'Unknown User Name';

    let arrySplitName = userName.trim().split(' ');
    let userNameLength = arrySplitName.length;

    let firstLetter = arrySplitName[0].charAt(0);
    let secondLetter = arrySplitName[userNameLength - 1].charAt(0);

    return (firstLetter + secondLetter).toLocaleUpperCase() || userName;
  }

  // this function using for normal errors messages
  public isInvalidControl(controlName: string): boolean {
    const control = this.formUserGroup.get(controlName);

    //

    if (!control) {
      return false;
    }
    return control.invalid && (control.touched || control.dirty);
  }

  public getErrorByField(controlName: string): string[] {
    const controlValue = this.formUserGroup.get(controlName)?.value;

    const errorObj = this.formUserGroup.get(controlName)?.errors;
    if (!errorObj) {
      return [];
    }
    const errorKeys = Object.keys(errorObj || {});
    if (errorKeys.length === 0) {
      return [];
    }

    const listMsg = errorKeys.reduce((res: string[], key: string) => {
      const msg = this.messageErrors[key];
      res.push(msg);
      return res;
    }, []);
    return listMsg;
  }

  showCropper(event: any): void {
    if (event.currentFiles[0]) {
      this.uploadAvatar!.showCancelButton = true;

      // pipe letter here
      this.uploadAvatar!.chooseLabel =
        AppHelper.StringFunctions.shortenFileName(
          event.currentFiles[0].name,
          8,
          5
        );

      this.fileLabel = event.currentFiles[0].name;

      const ref = this._dialogService.open(PhotoCropperComponent, {
        header: 'Edit Photo',
        width: '30.25rem',
        data: {
          file: event.currentFiles[0],
          isRound: true,
          ratio: 1 / 1,
        },
        closable: true,
        closeOnEscape: true,
        modal: true,
      });

      if (ref) {
        this.isDialogCropperVisible = true;
      }

      ref.onClose.subscribe({
        next: (res: any) => {
          if (res) {
            this.isPreviewAvatar = true;
            this.getCroppedAvatar(res);
          } else {
            this.uploadAvatar!._files = [];
            this.uploadAvatar!.showCancelButton = false;
            this.uploadAvatar!.chooseLabel = 'Upload file';
            this.uploadAvatar?.cd.markForCheck();
          }
          // Update isDialogCropperVisible
          this.isDialogCropperVisible = false;
        },
        error: error => {
          console.log(error);
        },
      });
    } else {
      this._notificationService.setMessage({
        type: AppConstant.MESSAGE_TYPE.WARNING,
        header: `Invalid File Type`,
        content: `Invalid file type. Allowed file types: .png, .jpg, .jpeg`,
      });
    }
  }

  openNotiSetting() {
    this.isOpenSetting$.next(true);
    const ref = this._dialogService.open(NotificationSettingComponent, {
      header: `Manage Notifications`,
      data: {
        userId: this.currentUser.id,
      },
      styleClass: 'style-class-dialog-custom',
      modal: true,
      closable: true,
    });

    ref.onClose.subscribe({
      next: (res: any) => this.isOpenSetting$.next(false),
      error: error => console.log(error),
    });
  }

  onButtonClickDialog(
    option: OptionButtonType,
    dialogType: DialogAction
  ): void {
    switch (option) {
      case AppConstant.OPTION_BUTTON.YES:
        switch (dialogType) {
          case 'Draft':
            this.flag_OpenDialog = false;
            this.closePanel();
            this.buildForm();
            this._confirmService.clearDialog();
            break;
          default:
            this._confirmService.clearDialog();
            break;
        }
        break;
      case AppConstant.OPTION_BUTTON.NO:
        this._confirmService.clearDialog();
        break;
      case AppConstant.OPTION_BUTTON.CANCEL:
        this._confirmService.clearDialog();
        break;
      default:
        break;
    }
  }

  onDestroy(): void {}

  countryChange(e: any) {
    const controlPhone = this.formUserGroup.get(this.fieldNameKeys.phone);
    const value = e?.value;

    // Only update dial code if phone is empty
    if (!controlPhone?.value) {
      const controlFlag = this.formUserGroup.get(this.fieldNameKeys.flag);
      const controlDialCode = this.formUserGroup.get(
        this.fieldNameKeys.dialCode
      );
      // For countries with duplicate codes (e.g., US), match by both code and region
      const valueDial = this.countries.find(dial => {
        if (value.code === dial.code) {
          // If region exists, match it; otherwise just match code
          return value.region ? dial.region === value.region : true;
        }
      });

      controlDialCode?.setValue(valueDial?.dialCode);
      controlFlag?.setValue(valueDial);
    }
  }
}
